import {get} from "lodash"

export default function isRPDeal(object: Object) {
  const isRPCurrency = get(object, "productConfig.products.[0].salePrice.currency", null) === "RP"
  return isRPCurrency
}
